import React from 'react'
import './index.css'







const Table = () => {
    return ( 
        <div className='md:mx-20 my-6 overflow-x-auto '>
           



<html>

<body>



<table>




<tr>

<th colSpan='9'>CIVIL DIMENSIONS FOR JHANSI SURAKSHA ELEVATOR</th>

</tr>

  <tr style={{backgroundColor:'#b4d6d9'}}>
    <td colSpan={2}>CAPACITY	</td>
    <td colSpan={2}>CAR INSIDE	</td>
    <td colSpan={2}>LIFT WELL	</td>   
    <td colSpan={2}>ENTRANCE</td>

 
  </tr>


  <tr>
   
    <td>PERSONS</td>
    <td>LOAD/KGS</td>
    <td>WIDTH</td>
    <td>DEPTH</td>
    <td>WIDTH</td>
    <td>DEPTH</td>
    <td>WIDTH</td>
    <td>HEIGHT</td>
    
  

  </tr>

  <tr>
   
   <td>15</td>
   <td>1020</td>
   <td>1000</td>
   <td>2400</td>
   <td>1800</td>
   <td>3000</td>
   <td>900</td>
   <td>2000</td>
   
 

 </tr>





  <tr>
   
   <td>20</td>
   <td>1360</td>
   <td>1300</td>
   <td>2400</td>
   <td>2200</td>
   <td>3000</td>
   <td>1200</td>
   <td>2000</td>
   
 

 </tr>


 <tr>
   
   <td>26</td>
   <td>1768</td>
   <td>1600</td>
   <td>2400</td>
   <td>2400</td>
   <td>3000</td>
   <td>1200</td>
   <td>2000</td>
   
 

 </tr>



 






 

</table>

</body>
</html>








        </div>

       





        
    )
}

export default Table